module.exports = __webpack_public_path__ + "static/media/hipster_7_bottom.5e19c8b1.svg";